<template>
  <div class="content-box">

    <div class="sub-catalog">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">首頁</el-breadcrumb-item>
          <el-breadcrumb-item>原書查詢</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="sub-line"></div>



    <div class="content">
      <div class="search-select">
              <input @keyup.enter="btnsearch"
              v-model="keyword"
              class="input"
                clearable
                placeholder="請輸入內容">
              <button  @click="btnsearch" class="search"></button>
              
        </div>


        <div class="img-box-list">

          <div v-for="book in booklist" :key="book" class="img-box" @click="bookclick(`${book.booknum}`)">
            <div class="img-container" >
              <div class="img" :style="{backgroundImage:'url(http://toolhg.qiushifang.com/resources/uploads/733e999b-874f-4a26-97ee-6d289379191d.jpg)'}">
                <div class="img-num">{{book.booknum}}</div>

              </div>
            </div>
            
            
            <div class="text-box">
              <div :title="book.bookname" :value="book.bookname" class="title-text" >
                {{book.bookname.substr(0,30)}}...
              </div>
              <div class="content-text">
                <span :value="book.bookauthor">{{book.bookauthor}}</span>
                
              </div>
            </div>

            <div class="key-word">
              <span>關鍵詞：</span>
              <span :value="book.title_keyword">{{book.title_keyword}}</span>
            </div>
          </div>

        </div>

        <div style="text-align: right;margin-top: 30px;">
              <el-pagination
                background
                :current-page="currentpage"
                :page-size="pagesize"
                layout="prev, pager, next"
                :total="totalcount"
                @current-change="current_change">
              </el-pagination>
            </div>

        



    </div>

    
    
  </div>
</template>

<script>
export default {
  name: "app",
  data() {
    return {
      sourceurl:'',
      pagesize:16,
      currentpage:1,
      totalcount:0,
      keyword:'',
      totaldata:'99999',
      booklist:[ ],//{ "ID": 5, "bookname": "测试书5", "bookauthor": "55", "keyword": "是个", "frontpage": "/11/a.png", "booknum": 5 }, { "ID": 4, "bookname": "测试书4", "bookauthor": "44", "keyword": "艾克", "frontpage": "/11/a.png", "booknum": 4 }, { "ID": 3, "bookname": "测试书3", "bookauthor": "33", "keyword": "哈哈", "frontpage": "/11/a.png", "booknum": 3 }, { "ID": 2, "bookname": "测试书2", "bookauthor": "22", "keyword": "条件", "frontpage": "/11/a.png", "booknum": 2 }, { "ID": 1, "bookname": "测试书", "bookauthor": "阿达", "keyword": "海关", "frontpage": "/11/a.png", "booknum": 1 } ],
    };
  },
  watch:{

  },
  methods: {
    bookclick(bookid){
      this.$router.push({ path: "/hgbookread_searchresult",query:{bid:bookid}});

    },
    current_change(val){
      this.currentpage=val;
      this.btnsearch();
    },
    //点击搜索按钮
    btnsearch(){
      this.$http
      .get(`${this.$store.state.baseurl}/api/hgbookread/getbooklist?page=`+this.currentpage+`&searchtxt=`+this.keyword)
      .then((res) => {
        let json =  JSON.parse(res.data);
        this.booklist = json.data;
        this.totalcount=json.dataSize;
        //console.log(this.booklist);
        
      });

    },
    getTime(date) {
      // let date = new Date()
      // return dateFormat("YYYY-mm", date)
      return date;
    },
  },
  created() {
  this.sourceurl=`${this.$store.state.sourceurl}../..`;
  this.btnsearch();
  },
};
</script>

<style scoped lang="scss">
.content-box {
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: #e5e2db;
  border-width: 0px 0px 1px 0px ;
	border-style: solid;
	border-color:#cec0b2;
}
.content {
  width: 1220px;
  margin-left: auto;
  margin-right: auto;
  padding-bottom: 15px;
  .page{
    .page-box{
      display: flex;
      align-items: flex-end;
      align-self: flex-end;

      .page-ele{
        border-radius: 50%;
        background-color: #c60828;
        width: 20px;
        height: 20px;
        padding: 5px 5px;
        margin: 20px 5px;
        color: #ffffff;

      }
    }
  }
}

.sub-catalog{
  width: 1220px;
  margin-left: auto;
  margin-right: auto;
  text-align: left;
  font-size: 14px;
  color: #666666;
  padding-top: 14px;
  padding-bottom: 14px;
  
}
.sub-line{
  border-width: 0px 0px 1px 0px ;
	border-style: solid;
	border-color:#cec0b2;
}

.search-select {
  display: flex;
  justify-content: center;
  padding-top: 20px;
  padding-bottom: 20px;
  .input {
    border-radius: 5px;
    width: 580px;
    height: 45px;
    padding-left: 20px;
    font-size: 14px;
    color: #999999;
    border: 0px;
  }
  .search {
    border-radius:5px;
    width: 100px;
    height: 45px;
    background: url("../assets/image/search.png") no-repeat;
    background-size:102px 45px;
    border-style: none;

  }

  
  
}

.img-box-list {
  width: 1220px;
  min-height: 600px;
  height:auto!important;
  margin: auto;
  display: flex;
  flex-direction: row;
  justify-content: start;
  flex-wrap: wrap;
  .img-box {
    width: 240px;
    height: 350px;
    margin: 28px;
    display: flex;
    flex-direction: column;
    text-align: left;
    background-color: #ffffff;
    border:  1px solid #c60828;
    border-radius: 10px;
    .img-container{
      width:220px;
      height:220px;
      margin-left: auto;
      margin-right: auto;
      margin-top: 10px;
      margin-bottom: 10px;
      border:  1px dotted #eeeeee;
      border-radius: 5px;
      .img{
        background-repeat: no-repeat;
        background-size: 100% 100%;
        -moz-background-size:100% 100%;
        width: 150px;
        height:200px;
        margin-left: 40px;
        margin-top: 10px;
        padding-left: auto;
        padding-right: auto;
        .img-num{
          padding-top: 160px;
          text-align:center;//水平居中
          line-height:20px;//跟高度一样
          color: #eeee00;
          

        }
      }

    }
    .text-box{
      height: 70px;
      font-size: 14px;
      border-width: 0px 0px 1px 0px ;
      border-style:dotted;
      border-color:#cec0b2;
      .title-text{
        width: 200px;
        margin-left: 20px;
        margin-right: 20px;
        color: #000;

      }
      .content-text{
        width: 200px;
        margin-left: 20px;
        margin-right: 20px;
        color: #906442;
        margin-top: 10px;
        span{
          padding-right: 15px;
        }

      }
    }
    .key-word{
      width: 200px;
      margin-left: 20px;
      margin-right: 20px;
      font-size: 12px;
      color: a9a9a9;
      padding-top: 10px;
      span{
        margin-right: 12px;
      }

    }
    
  }

}
</style>